import Dependencies from '../utilities/dependencies';
import DateFormat from "../utilities/date-format";

export default class BookingForm {

	/**
	 * CSS selectors that must exist for this module to run
	 * @see {@link https://docs.fastrackdev.com/front-end-development.html#javascript-development}
	 */
	static getHolderSelectors = () => ['.booking-form-wrap'];

	/**
	 * Dependencies that this module requires
	 * @see {@link https://docs.fastrackdev.com/front-end-development.html#javascript-development}
	 */
	static getDependencies = () => [
		Dependencies.libraries.pikaday
	];

	/**
	 * Runtime injected CSS classes
	 * @see {@link https://docs.fastrackdev.com/front-end-development.html#javascript-development}
	 */
	static getClassList = () => Object.create({});

	/** @type {HTMLElement} */
	#holderElement;

	/** @type {HTMLElement} */
	#checkInPicker;

	/** @type {HTMLElement} */
	#checkOutPicker;

	/**
	 * @param {HTMLElement} holderElement
	 */
	constructor(holderElement) {
		this.#holderElement = holderElement;
		this.#checkInPicker = this.#holderElement.querySelector('.js-check-in');
		this.#checkOutPicker = this.#holderElement.querySelector('.js-check-out');
		this.onload();
	}

	onload() {
		const checkInPicker = new Pikaday({
			field: this.#checkInPicker,
			// trigger: $btn[0],
			// container: $(this)[0],
			format: DateFormat.NICE,
			minDate: new Date(),
			container: this.#holderElement.querySelector('.check-in-field-wrapper'),
			// firstDay: 1,
			onSelect: () => {
				let hiddenCheckInPicker = this.#holderElement.querySelector('.js-check-in-hidden');
				hiddenCheckInPicker.value = DateFormat.format(new Date(this.#checkInPicker.value), DateFormat.ISO_8601);
			},
			toString: (date, format) => {
				return DateFormat.format(date, format);
			}
		});
		const checkOutPicker = new Pikaday({
			field: this.#checkOutPicker,
			// trigger: $btn[0],
			// container: $(this)[0],
			format: DateFormat.NICE,
			minDate: new Date(),
			container: this.#holderElement.querySelector('.check-out-field-wrapper'),
			// firstDay: 1,
			onSelect: () => {
				let hiddenCheckOutPicker = this.#holderElement.querySelector('.js-check-out-hidden');
				hiddenCheckOutPicker.value = DateFormat.format(new Date(this.#checkOutPicker.value), DateFormat.ISO_8601);
			},
			toString: (date, format) => {
				return DateFormat.format(date, format);
			}
		});
	}
}
